<template lang="pug">
div
    mixin product(product)
        div.row
            div.col-xs-5
                small {{ orderProductName(product) }}
                div(v-if="product.voided_by !== null")
                  span.block(v-if="product.void_remarks !== ''")
                    i.material-icons.voided &#xe15c;
                    small.m-l-xs {{ product.void_remarks }}
                  span.block
                    i.material-icons.voided &#xe7fd;
                    small.m-l-xs {{ product.voided_staff.name }}
            div.col-xs-2
                small @{{ product.unit_price }}
            div.col-xs-2
                small.pull-right x(-{{ product.quantity }})
            div.col-xs-3
                small.pull-right {{ orderProductPrice(product) }}

    div.row(v-if="orderProducts.length")
        div.col-xs-12
            hr

    div.row(v-if="returnedOrderProducts.length")
        .col-xs-12
            small.dark.block.text-center.m-y-sm Returned Item(s)

    div(v-for="group in groupReturnedOrderProducts")
        div.row.grand-total-amount
            div.col-xs-6
                small._500 Date: {{ refundDate(group.refunded_at) }}
            div.col-xs-6
                small._500 Time: {{ refundTime(group.refunded_at) }}

        div(v-for="product in group.products")
            +product(product)

    div.row(v-if="orderProducts.length")
        div.col-xs-12
            hr
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import StoreMixin from './store-mixin';
import { mapGetters } from 'vuex';

export default {
    mixins: [receiptMixin, StoreMixin],

    computed: {
        ...mapGetters('transaction', [
            'orderProducts',
            'returnedOrderProducts',
        ]),

        groupReturnedOrderProducts() {
            const grouped = _.groupBy(
                this.returnedOrderProducts,
                'refunded_at',
            );

            const results = [];

            _.forEach(grouped, (rows, refunded_at) => {
                results.push({
                    refunded_at: refunded_at,
                    products: rows,
                });
            });

            return results;
        },
    },

    methods: {
        refundDate(date) {
            return moment(date)
                .format('DD MMM YYYY')
                .toUpperCase();
        },

        refundTime(date) {
            return moment(date).format('HH:mm:ss');
        },
    },
};
</script>

<style lang="scss" scoped>
.voided {
    font-size: 14px;
    vertical-align: middle;
}
.grand-total-amount {
    border: 1px solid #666;
    border-radius: 10px;
    margin-left: 0;
    margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt-postgres/return-orders.vue